import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Building2, Target } from "lucide-react";
import PublicLayout, { PageHero } from "../../components/PublicLayout";
import { useLang } from "../../context/LanguageContext";

const icons = [Building2, MapPin, Target];

const About = () => {
  const { t } = useLang();
  const paragraphs = t("pages.about.paragraphs");
  const cards = t("pages.about.cards");
  return (
    <PublicLayout>
      <PageHero eyebrow={t("pages.about.eyebrow")} title={t("pages.about.title")} subtitle={t("pages.about.subtitle")} />
      <section className="max-w-[760px] mx-auto px-6 pb-16">
        <div className="space-y-6 text-[16px] leading-relaxed text-neutral-300">
          {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
          {cards.map((c, i) => {
            const Icon = icons[i];
            return (
              <div key={c.title} className="rounded-2xl border border-[#2A2A2A] bg-[#181818] p-5"><Icon size={20} className="text-[#FF5C00]" /><div className="text-white font-semibold mt-3">{c.title}</div><div className="text-[13px] text-neutral-500 mt-1">{c.text}</div></div>
            );
          })}
        </div>
      </section>
      <section className="max-w-[760px] mx-auto px-6 pb-24 text-center">
        <Link to="/contact" className="inline-flex items-center gap-2 bg-[#181818] hover:bg-[#232326] border border-[#2A2A2A] text-white font-semibold px-7 py-3.5 rounded-xl transition-colors">{t("common.getInTouch")}</Link>
      </section>
    </PublicLayout>
  );
};

export default About;
